module.exports = __webpack_public_path__ + "static/media/FileShield.f925b533.svg";